import { createFileRoute } from "@tanstack/react-router";
import ServicesPage from "@/pages/ServicesPage";
import { buildHead, SITE_URL } from "@/lib/seo-head";

export const Route = createFileRoute("/services/")({
  head: () =>
    buildHead({
      title: "Interior Design & Fit-Out Services in Bahrain | Abacus",
      description:
        "Interior design, turnkey fit-out, custom joinery, MEP, architectural lighting, digital signage, metalwork and renovation across Bahrain and the GCC.",
      path: "/services",
      schemaJson: {
        "@context": "https://schema.org",
        "@type": "ItemList",
        name: "Abacus Design Solutions Services",
        url: `${SITE_URL}/services`,
      },
    }),
  component: ServicesPage,
});
